/**
 * 공지 보기 팝업 (/adm/notice/{id} — 레이아웃 없는 단독 창)
 * ($j.Pages.Admin.NoticeShow / body data-page-name="NoticeShow")
 */
export default class NoticeShow {
    initialize() {
        // 첨부 그림을 누르면 새 창에 원본 크기로
        $('img.ns-img').on('click', function () {
            window.open(this.dataset.big, 'image', 'width=800,height=800');
        });
    }
}
